<div class="flex flex-column justify-content-center align-items-center w-full md:px-8 pb-3">
    <h2 class="text-center">Send feedback, ask questions, and more.</h2>
    <span class="text text-center">if you need help, have a feature request, or have run into a bug, check out our support center.</span>
    <div class="w-full mx-auto mt-4">
        <p-button
          label="Learn More"
          styleClass="learn-btn w-full"
          severity="info"
        ></p-button>
        </div>  
        <span class="text text-center mt-3">
            You can also email us:
            <a
              href="mailto:support@dollarflightclub.com"
              class="underline text-gray-600"
            >
              support&#64;dollarflightclub.com
            </a>
          </span>
</div>
